//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TaggedObject.js";
import "../no/LineFontBuilder.js";
import "../Annotations/Annotations.StyleBuilder.js";
import "../no/LineFontBuilder.js";
let d=[[[0,"ArrowDirection",1,0],[0,"ArrowLength",1,0],[0,"Color",1,0],[0,"CuttingPlaneSymbolText",1,0],[0,"DisplayCuttingPlaneSymbol",1,0],[1,"Font",0,"LineFontBuilder",0],[0,"MarginPercentage",1,0],[0,"ShadedPlane",1,0],[0,"SizeBasedOnSectionCut",1,0],[1,"Style",0,"Annotations.StyleBuilder",0],[0,"TextPlaneRelativeToArrow",1,0],[0,"UseTwoArrows",1,0],[0,"ViewNameFormat",1,0]],[[[],"AlternateArrow",{},0,0],[[],"AlternateArrowRotation",{},0,0],[["cuttingPlaneSymbolName","checkCPSPreviewObj"],"IsValidCPSName",{R_:{isValidCPSName:''}},2,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Annotations.CuttingPlaneSymbolBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.CuttingPlaneSymbolBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.CuttingPlaneSymbolBuilder.ViewNameFormatOption = Object.freeze({
    "UserDefined" : "UserDefined", "A" : "A", "AA" : "AA"});

SPLM.Annotations.CuttingPlaneSymbolBuilder.TextPlaneRelativeArrow = Object.freeze({
    "Parallel" : "Parallel", "Perpendicular" : "Perpendicular"});

SPLM.Annotations.CuttingPlaneSymbolBuilder.ArrowDirectionOption = Object.freeze({
    "Towards" : "Towards", "Away" : "Away"});

export default SPLM;